import React from 'react';
import { Row, Col } from 'react-bootstrap';
import TextContent from '../../../_common/TextContent';
import '../EquipmentProfile.scss';
import { CustomButton, Loading } from '../../../_common';
import { useMutation } from '@apollo/client/react';
import { EDIT_ASSET_LOAD_PROGRESS } from '../../../../graphql/client/mutations';
import { toastOpt } from '../../../../utils/helpers/toastHelper';
import { toast } from 'react-toastify';
import { GET_ASSET_INFO, GET_ASSET_LOADS } from '../../../../graphql/client/queries';

interface EquipmentDriverDetailsProps {
    loadId?: number | null;
    status?: string | null;
    trailerType?: string | null;
    trailer?: string | null;
    truckNumber?: string | null;
    carrierName?: string | null;
    driverName?: string | null;
    showRFD?: boolean;
}

const EquipmentDriverDetails = ({
    loadId,
    status,
    trailerType,
    trailer,
    truckNumber,
    carrierName,
    driverName,
    showRFD,
}: EquipmentDriverDetailsProps): React.ReactElement => {
    const [editAssetLoadProgress, { loading: mutationLoading }] = useMutation(EDIT_ASSET_LOAD_PROGRESS, {
        onCompleted: () => {
            toast.success('Asset load status updated successfully', toastOpt);
        },
        onError: (error) => {
            toast.error(error.message, toastOpt);
        },
        refetchQueries: [
            {
                query: GET_ASSET_INFO,
                variables: { loadId: loadId },
            },
            {
                query: GET_ASSET_LOADS,
                variables: { loadId: loadId },
            },
        ],
    });
    const handleOnClickRFD = (currentStatus: string, newStatus: string) => {
        editAssetLoadProgress({
            variables: {
                input: {
                    loadId: loadId,
                    currentValues: {
                        status: currentStatus,
                    },
                    newValues: {
                        status: newStatus,
                    }
                }
            }
        })
    }

    return (
        <Col>
            <Row className="LoadDetail-Title">Driver Details</Row>
            <Row>
                <TextContent hasTopMargin title={'Trailer Type: '} value={trailerType || ''} />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Trailer ID: '} value={trailer || ''} />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Truck Number: '} value={truckNumber || ''} />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Carrier: '} value={carrierName || ''} />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Driver: '} value={driverName || ''} />
            </Row>
            {status === "Created" && showRFD && trailerType && trailerType !== '' && (
                <Row className='custom-driver-button'>
                    <CustomButton isBordered title='Ready for Dispatch' onClick={() => handleOnClickRFD(status, "ReadyForDispatch")} />
                    {mutationLoading && <Loading />}
                </Row>
            )}
        </Col >
    );
};

export default EquipmentDriverDetails;
